export default __webpack_public_path__ + "static/media/add-exam.e54912ef.svg";